import React, { createContext } from 'react';
import { MandatoryChildren } from '../models/children-props';
import { MediaUploadType, useMediaUpload } from '../hooks/useMediaUpload';

const queueUploads: MediaUploadType['queueUploads'] = () => {
  // empty
};

export const MediaUploadContext = createContext<MediaUploadType>({
  uploads: {},
  queueUploads,
  deleteUpload: () => {
    // empty
  }
});

export const MediaUploadProvider = ({ children }: MandatoryChildren): JSX.Element => {
  const { uploads, queueUploads, deleteUpload } = useMediaUpload();
  const value: MediaUploadType = {
    uploads,
    queueUploads,
    deleteUpload
  };
  return <MediaUploadContext.Provider value={value}>{children}</MediaUploadContext.Provider>;
};
